import React from 'react'
import Rotas from './routes'
import { WhatsAppFloat } from './components/WhatsAppFloat'

function App() {
  return (
    <>
      <div className="min-h-screen">
        <Rotas />
      </div>
      <WhatsAppFloat />
    </>
  );
}

export default App;
